export const SHARE_DASHBOARD_MESSAGES = {
  error: 'An error occured',
  success: 'Successfully shared',
  loading: 'Please wait...',
}
